module.exports = __webpack_public_path__ + "media/images/lamp/red-4fae8a223b8c5f48a342a96d9d41fe93.png";